window.GGiftProduct = (function() {
    function Product() {
        this.init();
    }

    Product.prototype.init = function() {
        // OPTION 4
        // Change the 'Characters remaining' text AND all required error messages
        window.Shoppad = window.Shoppad || {},
            window.Shoppad.apps = window.Shoppad.apps || {},
            window.Shoppad.apps.infiniteoptions = window.Shoppad.apps.infiniteoptions || {},
            window.Shoppad.apps.infiniteoptions.strings = {
                charactersRemaining: 'Caracteres restantes',
                errorMessages: {
                    forTextInputs: "Por favor agregue su texto personalizado antes de agregar este artículo al carrito.",
                    forNumberInputs: "Por favor ingrese un número antes de agregar este artículo al carrito.",
                    forCheckboxes: "Por favor seleccione sus opciones antes de agregar este artículo al carrito.",
                    forMinimumValues: "Por favor seleccione al menos opciones %valuesmin antes de agregar este artículo al carrito.",
                    forDynamicCheckout: "Este producto no se puede comprar con este método de pago. Agregue el artículo al carrito, luego proceda a pagar desde el carrito.",
                    forDropdowns: "Por favor seleccione una opción antes de agregar este artículo al carrito"
                }
            };
    };

    return Product;
})();

$(function() {
    var product = new window.GGiftProduct();
});
